<template>
  <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
    <!-- Name -->
    <b-form-group :label="$t('patrol_logs.revision_code.name')" label-for="name">
      <b-form-input
        id="name"
        v-model="formData.name"
        :placeholder="$t('patrol_logs.revision_code.name')"
        trim
      />
    </b-form-group>

    <!-- Router Number -->
    <b-form-group :label="$t('patrol_logs.revision_code.code')" label-for="code">
      <b-form-input
        id="code"
        v-model="formData.code"
        :placeholder="$t('patrol_logs.revision_code.code')"
        trim
      />
    </b-form-group>

    <!-- Form Actions -->
    <div class="d-flex mt-2">
      <b-button variant="primary" class="mr-2" type="submit">
        {{ isAdd ? $t('actions.add') : $t('actions.update') }}
      </b-button>
      <b-button variant="outline-secondary" type="reset">
        {{ $t('actions.cancel') }}
      </b-button>
    </div>
  </b-form>
</template>

<script>
import { BForm, BFormGroup, BFormInput, BFormCheckbox, BButton } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BButton,
    vSelect,
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
    isAdd: {
      type: Boolean,
      required: true,
    },
    unitOptions: {
      type: Array,
      default: () => [],
    },
  },
  setup(_, { emit }) {
    const onSubmit = () => {
      emit('submit')
    }

    const onReset = () => {
      emit('reset')
    }

    return {
      onSubmit,
      onReset,
    }
  },
}
</script>
